import { ClientConfig } from '@sanity/client';
import { LineOfBusiness } from '@spotify-internal/pillow-talk';
import { PropertyRef } from '@spotify-internal/remote-config-properties';

export enum Vertical {
  ARTISTS = 'artists',
  CONSUMER = 'consumer',
  PODCASTERS = 'podcasters',
  FINDAWAY = 'findawayvoices',
}

export enum ColorScheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export type RolloutConfig = {
  rolloutProperty: PropertyRef<boolean>;
  fallbackUrl: string;
};

export type VerticalConfig = {
  verticalName: Vertical;
  pathParam: string;
  cms: ClientConfig;
  features: FeatureConfig;
  locales: LocaleConfig;
  theme: `encore-${string}-theme`;
  colorScheme: ColorScheme;
  rolloutConfig: null | RolloutConfig;
};

export type VerticalConfigs = Record<Vertical, VerticalConfig>;

export enum MastheadVariants {
  S4A = 's4a',
  TURNKEY = 'turnkey',
}

export type PillowTalkConfig = {
  lineOfBusiness: LineOfBusiness; // line of business
  redirectUri: string; // redirect uri
  showLoginDialog: boolean; // show login nudge when start a conversation
};

export type MastHeadConfig = {
  header: MastheadVariants; // header masthead variant
  footer: MastheadVariants; // footer masthead variant
};

export type FeatureConfig = {
  showHeaderGradient?: boolean; // show header gradiant
  configureMasthead?: MastHeadConfig; // masthead config
  communityLink?: string; // show link to community on home page
  configurePillowTalk?: PillowTalkConfig; // pillow talk config
  supportEmail?: string; // email used to contact support
  onlyEmailSupport?: boolean; // only uses email to contact support
  emailMessagingFallback?: boolean; // uses email when chat is unavailable
  disableAuthenticatedFeatures?: boolean; // disable authenticated features
};

type LocaleConfig = {
  smartling: Record<string, string>;
  messagingLocales: Readonly<Array<string>>;
};
